import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../lib/firebase';
import { Need } from '../types/need';

interface SaveNeedsParams {
  reportId: string;
  reportType: Need['reportType'];
  department: string;
  needsNotes: string;
  reportDate: string;
}

export async function saveNeedsFromNotes({
  reportId,
  reportType,
  department,
  needsNotes,
  reportDate
}: SaveNeedsParams): Promise<void> {
  if (!needsNotes || needsNotes.trim() === '') {
    return;
  }

  try {
    // Split the needs notes by lines and filter out empty lines
    const needsLines = needsNotes
      .split('\n')
      .map(line => line.trim())
      .filter(line => line.length > 0);

    // Create a need document for each line
    for (const needDescription of needsLines) {
      const needData: Omit<Need, 'id'> = {
        reportId,
        reportType,
        department,
        description: needDescription,
        isAddressed: false,
        priority: 'medium', // Default priority
        reportDate,
        createdAt: new Date()
      };

      await addDoc(collection(db, 'needs'), {
        ...needData,
        createdAt: serverTimestamp(),
      });
    }

    console.log(`${needsLines.length} besoins sauvegardés pour le rapport ${reportId}`);
  } catch (error) {
    console.error('Erreur lors de la sauvegarde des besoins:', error);
    throw error;
  }
}